import { createContext } from 'react'
import { RecommendedArticles_recommendedArticles_articles } from '@apollo-types/RecommendedArticles'

export const RecommendedArticlesContext = createContext<
  Partial<RecommendedArticles_recommendedArticles_articles[]>
>([])
RecommendedArticlesContext.displayName = 'RecommendedArticlesContext'

export const RecommendedArticlesContextProvider = RecommendedArticlesContext.Provider
